import Button from '@/components/Button.jsx';
import { FiKey } from '@/components/react-icons/main';
import { AddIcon } from '@/lib/constants/icons.js';
import stepActions from '@/screens/workflows/redux/actions/stepActions.js';
import ConditionalAuthSection from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/appPanel/appCredentialsPane/ConditionalAuthSection.jsx';
import { randomId } from '@shared/utils/randomId.js';
import SliderClose from './SliderClose.jsx';
import SliderHeader from './SliderHeader.jsx';
import SliderTitle from './SliderTitle.jsx';

const ConditionalAuthSlider = ({ onClose, disabled = false }) => {
  const handleAdd = () => {
    const authId = randomId();
    stepActions.set('options.conditionalAuth', (n) => [...(Array.isArray(n) ? n : []), { id: authId, operator: 'eq' }]);
  };

  const handleDelete = () => {
    stepActions.set('options.conditionalAuth', []);
    onClose();
  };

  return (
    <>
      <SliderHeader onClose={onClose} showDelete={true} onDelete={handleDelete} disabled={disabled} />
      <SliderTitle icon={FiKey} title={'Conditional Auth'} description={'You can use logic to change which connection to use when the step runs.'} helpIconContext={'workflowStepConditionalAuthContext'} />
      <ConditionalAuthSection disabled={disabled} />
      <Button className={'full-width'} size={'xl'} icon={AddIcon} onClick={handleAdd} id={'add-credential'} disabled={disabled}>
        Add Condition
      </Button>
      <SliderClose onClose={onClose} />
    </>
  );
};

export default ConditionalAuthSlider;
